import { get, post } from '../Services/http';
import { catchError } from './Error.action';
import { showLoader, hideLoader } from '../Actions/Loader.action';
import { showResult, hideResult } from '../Actions/ModalResult.action'
import { PayInvoicesStep } from '../constants';
import { translate } from '../../Services/translation';

export const PAYINVOICES_RECEIVE = 'PAYINVOICES_RECEIVE';
export const PAYINVOICES_ERROR = 'PAYINVOICES_ERROR';
export const PAYINVOICES_DESCRIPTION_RECEIVE = 'PAYINVOICES_DESCRIPTION_RECIEVE';
export const PAYINVOICES_PAYMENT_STATUS = 'PAYINVOICES_PAYMENT_STATUS';
export const PAYINVOICES_INVOICESTOPAY_STATUS = 'PAYINVOICES_INVOICESTOPAY_STATUS';

export const receive = (data, isLoaded) => ({
    type: PAYINVOICES_RECEIVE,
    payload: {
        invoiceList: data,
        invoicesLoaded: isLoaded,
    },
});

export const setError = (error) => ({
    type: PAYINVOICES_ERROR,
    payload: {
        error,
    },
});

export const receiveDescription = (data) => ({
    type: PAYINVOICES_DESCRIPTION_RECEIVE,
    payload: data,
});

export const setPaymentStatus = (data) => ({
    type: PAYINVOICES_PAYMENT_STATUS,
    payload: data,
});

export const setInvoicesToPayStatus = (data) => ({
    type: PAYINVOICES_INVOICESTOPAY_STATUS,
    payload: data,
});

export const getInvoicesToPay = () => (dispatch) => {
    dispatch(showLoader());
    dispatch(receive(null, false));

    get('api/erp/invoicesToPay')
        .then((response) => response.json())
        .then((result) => {
            dispatch(receive(result, true));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const getPayInvoicesDescription = () => (dispatch) => {
    get('api/erp/payInvoicesDescription')
        .then((response) => response.json())
        .then((result) => {
            dispatch(receiveDescription(result?.payInvoicesDescription ?? ''));
            dispatch(showLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const goBackToInvoiceList = () => (dispatch) => {
    dispatch(
        setPaymentStatus({
            currentPaymentStep: PayInvoicesStep.List,
        })
    );
};

export const checkBeforePayment = (paymentMethod, invoices) => (dispatch) => {
    dispatch(showLoader());
    post('api/erp/checkBeforePayment', { paymentMethod, invoices })
        .then((response) => response.json())
        .then((result) => {
            dispatch(
                setPaymentStatus({
                    currentPaymentStep: result.succeeded ? PayInvoicesStep.Checkout : PayInvoicesStep.Failed,
                    paymentStatusText: result.statusText,
                    paymentTransactionId: result.transactionId
                })
            );
            dispatch(hideLoader());
        })
        .catch((ex) => {
            if (ex?.response) {
                ex.response.text().then((error) => {
                    dispatch(
                        setPaymentStatus({
                            currentPaymentStep: PayInvoicesStep.Failed,
                            paymentStatusText: 'Error in Check: ' + error,
                        })
                    );
                    dispatch(hideLoader());
                });
            }
        });
};

export const payInvoices = (paymentMethod, invoices, paymentTransactionId) => (dispatch) => {
    dispatch(showLoader(translate('code.mypage.payinvoices.processingpayment')));
    post('api/erp/payInvoices', { paymentMethod, invoices, paymentTransactionId })
        .then((response) => response.json())
        .then((result) => {
            dispatch(
                setPaymentStatus({
                    currentPaymentStep: result.succeeded ? PayInvoicesStep.Succeeded : PayInvoicesStep.Failed,
                    paymentStatusText: result.statusText,
                    paymentTransactionDate: result.transactionDate,
                    paymentTransactionId: result.transactionId
                })
            );
            dispatch(hideLoader());
            if(result.succeeded) {
                dispatch(showResult(translate('code.mypage.payinvoices.succeeded.title'), "check_circle", true));
            }
            else {
                dispatch(showResult(translate('code.mypage.payinvoices.failed.title'), "cancel", false));
            }
        })
        .catch((ex) => {
            if (ex?.response) {
                ex.response.text().then((error) => {
                    dispatch(
                        setPaymentStatus({
                            currentPaymentStep: PayInvoicesStep.Failed,
                            paymentStatusText: error,
                            paymentTransactionDate: Date.now().toString(),
                            paymentTransactionId: paymentTransactionId
                        })
                    );
                    dispatch(hideLoader());

                    // TODO: Check this? shouldn't it be dispatch(showResult(translate...) ?
                    dispatch(translate('code.mypage.payinvoices.failed.title'), "cancel", false);
                });
            }
        });
};
